import Folder from '../src/Folder/index';
export default Folder;
